export default __webpack_public_path__ + "static/media/rocket_anim_69.a59ceb70.png";